module.exports = __webpack_public_path__ + "/images/meeting-selected.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/meeting-selected.svg
// module id = 622
// module chunks = 0